<mat-card class="card-user-claim-form mat-elevation-z8">
    <mat-card-subtitle>Add New Document</mat-card-subtitle>
    <mat-card-content>

        <form [formGroup]="documentForm" novalidate>   
            
            <mat-form-field style="width: 0; height: 0;" >
                <input matInput hidden  formControlName="docStereoTypeId" readonly>
            </mat-form-field>

            <mat-form-field class="form-element">
                <input matInput placeholder="Name" disabled="disabled" formControlName="name">
            </mat-form-field>
        </form>
        <mat-action-row>
            <button mat-button (click)="addDocument()" color="primary">Add New Document</button>
        </mat-action-row>
    </mat-card-content>
</mat-card>
